import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { InputAdornment, } from "@material-ui/core";
import { defaultDateProps, useRootStyles } from "./globalprops"
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import { Loading } from "./Loading";
import { ICommonControlWithMinMaxWithLabel } from "./ICommonInputsControls";
import { useTranslation } from 'react-i18next';



// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonControlWithMinMaxWithLabel<Date>;
export const DateSelect = (props: AllProps) => {
    const classes = useRootStyles(useTheme());
    const { t } = useTranslation('common');
    
    const [selectedDate, setSelectedDate] = React.useState(props.value === undefined ? null : props.value);
    const [error, setError] = React.useState(props.error || [false, ""]);


    const errorStuff = error && error[0] ? ({
        error: true,
        helperText: error[1]
    }) : undefined;

    const update = (date: Date | null) => {
        if (date && isNaN(date.getTime())) {
            // Handle invalid date
            setError(date === null ? [false, ""] : [true, t('invalidDate')]); // Set an error message
            props.onChange && props.onChange(null, false); // Pass null to indicate invalid date
            return;
        }

        if (!date && props.required) {
            setError([true, t('xIsRequired', {x: props.label})]);
            props.onChange && props.onChange(null, false); // Pass null to indicate invalid date
            return;
        }

        const day = date ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12) : null;
        setSelectedDate(day);

        if (props.error) {
            setError(props.error);
            props.onChange && props.onChange(day, false);
            return;
        }

        const validationErrorReport = (props.onValidate && props.onValidate(day)) || [false, ""];
        setError(validationErrorReport);

        // Check if the date is within the min and max range
        const isError = validationErrorReport[0] ||
            (props.minValue && day && day < props.minValue) ||
            (props.maxValue && day && day > props.maxValue) || 
            false;

        props.onChange && props.onChange(day, isError === false);
    }

    React.useEffect(() => {
        props.prevalidate && update(selectedDate);
    }, []);

    React.useEffect(() => {
        setSelectedDate(props.value === undefined ? null : props.value);
    }, [props.value, props.error]);

    

    return props.loading ? <Loading label={props.label} />: <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker 
            {...defaultDateProps}
            className={classes.root}
            label={props.label}
            value={selectedDate}
            onChange={update}
            disabled={props.disabled}
            required={props.required}
            autoOk={true}
            minDate={props.minValue}
            maxDate={props.maxValue}

            minDateMessage={t('xMustBeBetweenYAndZ', { x: props.label, y: props.minValue?.toLocaleDateString() || "", z: props.maxValue?.toLocaleDateString() || "" })}
            maxDateMessage={t('xMustBeBetweenYAndZ', { x: props.label, y: props.minValue?.toLocaleDateString() || "", z: props.maxValue?.toLocaleDateString() || "" })}
            format={t('dateFormat')}
            InputProps={{
                startAdornment : props.icon && <InputAdornment position="start">{props.icon}</InputAdornment>
            }}
            {...errorStuff}
        />
    </MuiPickersUtilsProvider>
}
